import { Block, Inline } from '@contentful/rich-text-types';
import _ from 'lodash';
import React from 'react';

export const AssetHyperlink = ({ data, children }: React.PropsWithChildren<Block | Inline>) => {
    const url = _.get(data, 'target.fields.file.en-US.url');

    return <a href={url} target="_blank" rel="noreferrer">{children}</a>;
};
